import { defineComponent, reactive } from 'vue';
import { MainTitle, ReportTabList } from '@/components';
import { PVGenerationContainer } from '@/containers';
export default defineComponent({
    name: 'PvGeneration',
    components: {
        MainTitle,
        ReportTabList,
        PVGenerationContainer,
    },
    setup() {
        const state = reactive({
            tabname: 'hourly',
        });
        return { state };
    },
});
